import actions from './actions/index'
import getters from './getters/index'
import mutations from './mutations/index'

let loggedIn = false
if (localStorage.getItem('token')) {
  loggedIn = true
}

/**
 * The initial state
 *
 * @constant {object}
 */
const state = {
  loggedIn,
  loginError: null,
  user: null,
  abilityGroups: [],
  account: null,
  devices: [],
  notifications: [],
  roles: [],
  numbers: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
